import React, { createContext, useState, useContext, useEffect } from 'react';

const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState('Tidal');
  const [config, setConfig] = useState(null);

  useEffect(() => {
    async function loadConfig() {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/config`);
        const data = await res.json();
        setConfig(data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to fetch config', e);
      }
    }
    loadConfig();
  }, []);

  return (
    <ClientContext.Provider value={{ selectedClient, setSelectedClient, config }}>{children}</ClientContext.Provider>
  );
};

export const useClient = () => useContext(ClientContext);
